import { MealTime } from "@/clients/models/MealTime";
import { mealTabs, mealTabsLabel } from "@/constants/meal-tab";
import { cn } from "@/utils/cn";
import { memo } from "react";

interface MealTimeSegmentButtonsProps {
  selected: MealTime;
  onSelect?: (mealTime: MealTime) => void;
}

export const MealTimeSegmentButtons = memo(function MealTimeSegmentButtons({
  selected,
  onSelect,
}: MealTimeSegmentButtonsProps) {
  return (
    <div className="w-full flex items-center gap-2 overflow-x-auto min-h-12! mt-2 no-scrollbar">
      {mealTabs.map((tab) => {
        const isActive = selected === tab;
        return (
          <button
            key={`${tab}`}
            className={cn(
              "text-sm font-medium rounded-md no-scrollbar px-4 py-2 transition-all duration-300",
              {
                "bg-purple-100 border-transparent": isActive,
                "bg-white border border-gray-100": !isActive,
                "cursor-pointer": onSelect,
              },
            )}
            disabled={!onSelect}
            onClick={() => onSelect?.(tab)}
          >
            {mealTabsLabel[tab]}
          </button>
        );
      })}
    </div>
  );
});
